export default __webpack_public_path__ + "static/media/hht2_direction_speakingpractice_04.138fdf17.png";